import React, { useState, useEffect } from "react";
import Preloader from "../../../components/Preloader/Preloader";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { addDays,format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import ButtonComponent from 'react-button-component';
import LoadingOverlay from 'react-loading-overlay';
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import DynamicTable from "../../../components/DynamicTable";
import { DateRangePicker } from "materialui-daterange-picker";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";


const useStyles = makeStyles((theme) => ({
	btnSearch: {
        marginTop: 30,
        backgroundColor: "green",
	},
    modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
    paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
}));
const BranchPackagePurchasePromo = (props) => {
    const refDataFilter = React.createRef();
    const classes = useStyles();
    const [nextPagePath, setNextPagePath] = useState("");
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
    const [idnoselected, setIdnoSelected] = useState("");
    const [eligibleforrelease, setEligibleRel] = useState("");
    const [isFS, setIfFS] = useState("");
    const toggle = () => setOpen3(!open3);
    const [posts, setPosts] = useState([]);
    const [releaseidno, setReleaseIdno] = useState("");
    const [selectedpackagetype, setSelectedPackageType] = useState("");
    const min_releasedate = '2021-04-01';
    const TransactionInformation = {};
    const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const nextpage =  {
		// pathname: "/package-sales-payment",
		pathname: "/branch-package-purchasepromo-firststep",
	}
    const headers = {
        'Content-Type': 'multipart/form-data',
    };
	//ApiData Component useState SOF
    const branch_package_purchase_list_promo = () => {
        // setisLoaded(false);
		//get data for warehouse/location dropdown
        const formData = new FormData();
		const form_data = {
			hqidno: branchIdNo,
            prep_data: prep_data
		}
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'branchpackagepurchaselistpromo';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            // loadBranchPackageList(res.data);
		});
	};

    const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen3(false);
	};

    const releasepackage = (idno) => {
        setShowOverlay(true);
        setOverlayMsg('Processing Release...');
		//get data for warehouse/location dropdown
        const formData = new FormData();
		const form_data = {
            hqidno: branchIdNo,
			idno: idno
		}
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'releasepackage';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("success");
				setTimeout(() => {
                    setShowOverlay(false);
                    setOverlayMsg('');
					setShowMsgBox(false);
				}, 3000)
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF

	//Table Settings
	const [TABLE_DATA, loadDataTable] = useState([]);
	const [selectedPackage, setSelectedPackage] = useState({});

    const release_branchpurchase = (dataIndex) => {
        TransactionInformation['id']= posts[dataIndex].id;
		TransactionInformation['soldto']= posts[dataIndex].branchname;
		TransactionInformation['refcode']= posts[dataIndex].referencecode;
        TransactionInformation['branchidno']= posts[dataIndex].branchidno;
        TransactionInformation['shippingcharge']= posts[dataIndex].shippingcharge;
        TransactionInformation['navname']= posts[dataIndex].packagetype;
        TransactionInformation['atype']= posts[dataIndex].atype;
        TransactionInformation['country']= posts[dataIndex].country;
        TransactionInformation['activationtype']= posts[dataIndex].activationtype;
        TransactionInformation['navcode']= posts[dataIndex].navcode;
        TransactionInformation['navid']= posts[dataIndex].navid;
        TransactionInformation['isfranchise']= "no";
        nextpage['transactionInfo'] = TransactionInformation;
        proceedtoencoding();
    }
    
	const loadBranchPackageList = (data) => {
        refreshTable();
		const newData = [...TABLE_DATA];
		for (let i=0;i < data.branchpackagesaleslist.length;i++) {
            if(data.branchpackagesaleslist[i].status == "Waiting for Confirmation")
			{
                const tempObj = {trandate:data.branchpackagesaleslist[i]['date'], branchname:data.branchpackagesaleslist[i]['branchname'], refno:data.branchpackagesaleslist[i]['packno'], atype:data.branchpackagesaleslist[i]['atype'], packagetype:data.branchpackagesaleslist[i]['packagetype'],  status:data.branchpackagesaleslist[i]['status'], 
                    action:<Grid container spacing={2}>
                                <Grid xs={12} sm={6}>
                                    <Button variant="contained" color="primary" onClick={(e) => {
									release_branchpurchase(data.rawbranchpackagesaleslist[i], data.branchpackagesaleslist[i]);
								}}>Encode</Button>
                                </Grid>
                            </Grid>
                    }
                newData.push(tempObj);
            }else{
                const tempObj = {trandate:data.branchpackagesaleslist[i]['date'], branchname:data.branchpackagesaleslist[i]['branchname'], refno:data.branchpackagesaleslist[i]['packno'], atype:data.branchpackagesaleslist[i]['atype'], packagetype:data.branchpackagesaleslist[i]['packagetype'],  status:data.branchpackagesaleslist[i]['status'], 
                    action:""
                    }
                newData.push(tempObj);
            }
        }
		loadDataTable([...newData]);
        // setisLoaded(true);
	};
    
	const refreshTable = () => {
        TABLE_DATA.length = 0;
        const newData = [...TABLE_DATA];
		loadDataTable([...newData]);
	}

	const columns = [
		{
		  name: 'date',
		  label: 'Date',
		}, {
		  name: 'branchname',
		  label: 'Branch Name',
		}, {
            name: 'id',
            label: 'Ref. No.',
        }, {
            name: 'atype',
            label: 'Account Type',
        }, {
            name: 'packagetype',
            label: 'Package',
        }, {
            name: 'status',
            label: 'Status',
        },  {
            name: 'id',
            label: 'Action',
            options: {
                setCellProps: () => ({ style: { minWidth: "100px", maxWidth: "100px" }}),
                    customBodyRenderLite: (data, type, row) => {
                    let status =  posts[data].status;
                    if(status == "Waiting for Confirmation")
                    {
                        return (
                            <Grid container spacing={2}>
                                <Grid xs={12} sm={6}>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        onClick={(e) => release_branchpurchase(data)}
                                    >
                                        Encode
                                    </Button>
                                </Grid>
                            </Grid>
                        );
                    }else{

                    }
                }
          },
        }
	];
	
	const TABLE_OPTION = {
        selectableRows: 'none'
	};
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
    const handleOpen2 = () => {
		setOpen2(true);
	};
    const handleOpen3 = () => {
		setOpen3(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
    const handleClose2 = () => {
		setOpen2(false);
	};
    const handleClose3 = () => {
		setOpen3(false);
	};
	//Modal Settings EOF
    const formatDate = (date) => {
		let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;

		return [year, month, day].join('-');
	}
    const proceedtoencoding = () => {
        props.history.push(nextpage);
    }
    //FormData
	const [prep_data, setData] = useState({"startDate":formatDate(new Date()),"endDate":formatDate(new Date())});
	//FormData EOF
	//OnLoad Event/Data Fetching SOF
	// Data Fetching
	useEffect(() => {
		onFetchedApi();
        branch_package_purchase_list_promo();
	}, []);
    //OnLoad Event/Data Fetching SOF

    // Date Picker
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const startDateChanged = (e) => {
        setStartDate(e);
        const newData = {...prep_data};
        newData['startDate']= formatDate(e);
        setData({ ...newData });
    }
    const endDateChanged = (e) => {
        setEndDate(e);
        const newData = {...prep_data};
        newData['endDate']= formatDate(e);
        setData({ ...newData });
    }

    const confirmrelease = (idno, packageid, packagetype) => {
        setReleaseIdno(idno);
        setSelectedPackageType(packagetype);
        if(packageid == 0){
            handleOpen2();
        }else{
            handleOpen();
        }
    }
    const onFetchedApi = () => {
		refDataFilter.current.onFetchApi();
	  };
    //Date Picker EOF
	return (
		<div className="page">
            <LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<Typography color="textPrimary">Branch Package Purchase Promo</Typography>
				</Breadcrumbs>
			</div>
            <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			<div className="page-container">
                <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                >
                   
                         <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen3(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open3}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
                            <Grid item xs={1} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={onFetchedApi}>Search</Button>
                            </Grid>
                        </Grid>    
            
                </MuiPickersUtilsProvider>
                <Grid item xs={12}>
                { 
                    // !isLoaded ?  <Preloader /> :										
					<DynamicTable
						title="Branch Package Purchase"
						columns={columns}
									rows={posts}
						setRows={setPosts}
						ref={refDataFilter}
						dateRange = { dateRange }
						
						url='branchpackagepurchaselistpromov2ready'
          			/>
                }
                </Grid>
			</div>
            </LoadingOverlay>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <h2 id="transition-modal-title">System Message</h2>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        Are you sure you want to release this package?
                                    </Grid>
                                </Grid>
                                <div className={classes.button}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={2}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose}
                                            className={classes.buttonMarginRight}
                                        >
                                            No
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <Button 
                                            variant="contained" 
                                            color="primary"
                                            onClick={(e) => {releasepackage(releaseidno);handleClose();}}
                                        >
                                            Yes
                                        </Button>
                                    </Grid>
                                    </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
		</div>
	);
};

export default BranchPackagePurchasePromo;
